import * as React from 'react';

const PADDING_HEIGHT = 10;
const MOVABLE_HALF_WIDTH = 30;

// interface TooltipOption {
//   clearOnTap?: boolean;
// }

const initialValueState = {
  isShow: false,
  top: 0,
  left: 0,
  item: '',
};

export const TooltipValueContext = React.createContext({
  ...initialValueState,
});

export const TooltipUpdaterContext = React.createContext({
  setTooltip: () => {},
  clearTooltip: () => {},
});

export const useTooltip = () => {
  const [valueState, setValueState] = React.useState(initialValueState);

  const setTooltip = React.useCallback((target, item, opts) => {
    const { top, left } = calcPosition(target);
    setValueState(prevState => ({
      ...prevState,
      top,
      left,
      item,
      isShow: true,
      opts,
    }));
  }, []);

  const clearTooltip = React.useCallback(() => {
    setValueState(prevState => {
      return prevState.isShow ? { ...prevState, isShow: false } : prevState;
    });
  }, []);

  React.useEffect(() => {
    window.addEventListener('touchstart', clearTooltip);
    window.addEventListener('scroll', clearTooltip);

    return () => {
      window.removeEventListener('touchstart', clearTooltip);
      window.removeEventListener('scroll', clearTooltip);
    };
  }, []);

  return [
    React.useMemo(() => valueState, [valueState]),
    React.useMemo(() => ({ setTooltip, clearTooltip }), []),
  ];
};

const calcPosition = (target) => ({
  top: getTargetOffset(target).bottomY + PADDING_HEIGHT,
  left: getTargetOffset(target).centerX,
});

const getTargetOffset = (target) => ({
  bottomY: target.getBoundingClientRect().top + target.getBoundingClientRect().height,
  centerX: target.getBoundingClientRect().left + (target.getBoundingClientRect().width / 2),
});

export const canMoveToTooltip = (e) => {
  const compareY = e.clientY >= getTargetOffset(e.currentTarget).bottomY;
  const compareX = e.clientX >= getTargetOffset(e.currentTarget).centerX - MOVABLE_HALF_WIDTH &&
                   e.clientX <= getTargetOffset(e.currentTarget).centerX + MOVABLE_HALF_WIDTH;
  return compareY && compareX;
};
